import { type UseQueryOptions, useQuery } from "@tanstack/react-query";

import { queryKeyMap } from "@/features/query-client";

import { fetchAccountingData } from "../api";

type ResponseType = Awaited<ReturnType<typeof fetchAccountingData>>;

export const useGetAccountingData = (
  loanApplicationId: number,
  options?: Partial<UseQueryOptions<ResponseType>>,
) =>
  useQuery({
    queryKey: queryKeyMap.getAccountingData(loanApplicationId),
    queryFn: async () => {
      return await fetchAccountingData(loanApplicationId);
    },
    initialData: {
      balanceSheetEntries: [],
      profitLossEntries: [],
      financialRatioEntries: [],
    },
    ...options,
  });
